import { AjaxService } from "../Helpers/AjaxService";
import { MasterData } from "../Models/MasterData";

export class MasterDataApi {
    private static instance: MasterDataApi;
    static getInstance() { return MasterDataApi.instance || (MasterDataApi.instance = new MasterDataApi()); }

    postChangeRequest(masterData: MasterData): Promise<void> {
        const ajaxService = AjaxService.getInstance();
        const data = new FormData();
        data.append("GrowerId", masterData.GrowerId);
        data.append("Name", masterData.Name);
        data.append("Name2", masterData.Name2);
        data.append("Address", masterData.Address);
        data.append("Address2", masterData.Address2);
        data.append("PostCode", masterData.PostCode);
        data.append("City", masterData.City);
        data.append("Contact", masterData.Contact);
        data.append("DeliveryAddress", masterData.DeliveryAddress);
        data.append("CompanyName", masterData.CompanyName);
        data.append("VatNo", masterData.VatNo);
        data.append("CprNo", masterData.CprNo);
        data.append("Constituency", masterData.Constituency);
        data.append("Delegate", masterData.Delegate);
        data.append("OrganicAuthNo", masterData.OrganicAuthNo);
        data.append("Email", masterData.Email);
        data.append("PhoneNo", masterData.PhoneNo);
        data.append("PhoneNoText", masterData.PhoneNoText);
        data.append("CellPhoneNo", masterData.CellPhoneNo);
        data.append("CellPhoneNoText", masterData.CellPhoneNoText);
        data.append("PhoneNo2", masterData.PhoneNo2);
        data.append("PhoneNo2Text", masterData.PhoneNo2Text);
        data.append("PhoneNo3", masterData.PhoneNo3);
        data.append("PhoneNo3Text", masterData.PhoneNo3Text);
        data.append("PhoneNo4", masterData.PhoneNo4);
        data.append("PhoneNo4Text", masterData.PhoneNo4Text);
        data.append("CellPhoneNo2", masterData.CellPhoneNo2);
        data.append("CellPhoneNo2Text", masterData.CellPhoneNo2Text);


        const apiUrl = `/Handlers/UserManagement/MasterDataChangeRequest.ashx`;
        return new Promise<void>((resolve) => {
            ajaxService.postWithFormData(apiUrl,
                data,
                () => {
                    resolve();
                });
        });
    }
}